import { render, staticRenderFns } from "./RestorePasswordModal.vue?vue&type=template&id=521f3674&"
import script from "./RestorePasswordModal.vue?vue&type=script&lang=js&"
export * from "./RestorePasswordModal.vue?vue&type=script&lang=js&"
import style0 from "./RestorePasswordModal.vue?vue&type=style&index=0&id=521f3674&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports